import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeCaracteristiquesMAPA } from '../models/TypeCaracteristiquesMAPA';
import { Step3 } from '../../../../shared/models/component-messages/mapaIN/step3';

@Component({
  selector: 'app-type-caracteristiquesMAPA',
  templateUrl: './type-caracteristiquesMAPA.component.html'
})
export class TypeCaracteristiquesMAPAComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCaracteristiquesMAPA';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	  
	@Input() caracteristiques: TypeCaracteristiquesMAPA;
    
  public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

